<div class="d-flex d-md-flex justify-content-between align-items-center m-b-10">
  <fui-heading [text]="'Manage Announcements'" [level]="5"></fui-heading>
  <button class="btn btn-secondary" (click)="editAnnouncement()">
    <fa-icon icon="plus"></fa-icon>
    Add
  </button>
</div>
<div class="row">
  <div class="col-md-12">
    @if (announcements && announcements.length) {
      @for (ann of announcements; track ann) {
        <myp-list-item
          [showImage]="false"
          [includeChevron]="false"
          [title]="ann.title"
          [item]="ann"
          [subData]="['Date: ' + ann.date && ann.date.toDate ? (ann.date.toDate() | date: 'MMM Do, YYYY') : '']"
        >
          <div class="button-content">
            <fa-icon icon="edit" placement="left" (click)="editAnnouncement(ann)" [ngbTooltip]="'Edit'" class="action circle-icon-btn m-r-10"></fa-icon>
            <fa-icon icon="times" placement="left" (click)="deleteAnnouncement(ann)" [ngbTooltip]="'Delete'" class="action circle-icon-btn"></fa-icon>
          </div>
        </myp-list-item>
      }
    }
  </div>
</div>
